//smooth vertical scroll to element
export function smoothScrollTo(target: number) {
    //exit if these aren't defined
    if (!document || !window) return;

    //most browsers can handle this
    if ("scrollBehavior" in document.documentElement.style) {
        window.scrollTo({ top: target, behavior: "smooth" });
        return;
    }

    //fallback safari behavior
    scrollTo(target);
}

function getScrollPosition() {
    return document.documentElement.scrollTop || document.body.scrollTop;
}

//recursive scroll
function scrollTo(target: number) {
    const current = getScrollPosition();
    const scrollBy = Math.ceil((target - current) * 0.2);

    if (Math.abs(scrollBy) < 5) {
        //close enough, finish up
        window.scrollTo({ top: target });

        //scroll correction (window.scrollto doesn't work as expected in safari at low zoom)
        const secondCheck = getScrollPosition();
        if (target !== secondCheck) {
            const distance = (target - secondCheck) * 2; //scroll by double the px difference
            window.scrollBy({ top: distance });
        }
    } else {
        //move by this amount and enqueue next scroll
        window.scrollBy({ top: scrollBy });
        setTimeout(() => {
            window.requestAnimationFrame(() => scrollTo(target));
        }, 10);
    }
}
